export interface ITemplateConfig {
    id: number
    column_configs: IColumnConfig[]
    banner_configs: IBannerConfig[]
    rating_column_name: string | null
    price_expression: string | null
}

export interface IColumnConfig {
    id: number
    label: string | null
    column_type: string
    col_span: number
    data_column_name: string | null
    background_color: string | null
    expression: string | null
    top_additional_expression: string | null
    bottom_additional_expression: string | null
    tooltip?: string | null
    button_config?: IButtonConfig
    show_rating: boolean
    wrapped_on_mobile: boolean
    wrapped_label: string | null
}

export interface IButtonConfig {
    id: number
    label: string
    color: string | null
    icon: string | null
    gtm_event: string | null
    target_self: boolean
    target_self_condition: string | null
    has_conditional_url: boolean
    conditional_url_expression: string | null
    fallback_text: string | null
    url_params?: IButtonUrlParam[] | null
}

export interface IButtonUrlParam {
    nameTargetColumn: string
    valueExpression: string
}

export interface IBannerConfig {
    id: number
    content: string | null
    fa_icon: string
    color: string
    enable_condition: string | null
    is_custom_banner: boolean
    banner_column_name: string | null
}

export interface IFilterConfig {
    id: number
    unique_id: number
    type: string
    filter_constraint: string
    target_column: string
    one_line_label: boolean
    col_span: number
    filter_order: number
    label?: string
    tooltip?: string | null
    label_icon?: string
    variable_name?: string
    display_condition?: string
    default_value?: any
    page_configs?: any
    dynamic_value_expression?: string
}

export interface IFiltersConfigPayload {
    filters: IFilterConfig[]
    sorting_rules: ISortingRule[]
    featured_offer_configs?: IFeaturedOfferConfig[]
    expression_filter: string
    display_filters_horizontally: boolean
    mobile_template_sticky: boolean
}

export interface ISortingRule {
    target_column: string
    sort_order: string
}

export interface IFeaturedOfferConfig {
    application_condition_expression: string
    offer_selection_expression: string
}

interface ISelectOption {
    label: string
    icon?: string
    value: any
    is_default: boolean
}

export interface ISelectFilterConfig extends IFilterConfig {
    is_multiple?: boolean
    is_strict_multiple?: boolean
    options?: ISelectOption[]
}

export interface IToggleFilterConfig extends IFilterConfig {
    left_label?: string
    right_label?: string
    left_value?: string
    right_value?: string
    icon?: string
}

export interface INumberFilterConfig extends IFilterConfig {
    addon_content?: string
    min_filter_value?: number
    max_filter_value?: number
}

export interface ISliderFilterConfig extends IFilterConfig {
    min_slider_value?: number
    max_slider_value?: number
    slider_step?: number
    suffix?: string
    show_median_value?: boolean
}

export interface IDateFilterConfig extends IFilterConfig {
    min_filter_date?: string
    max_filter_date?: string
    addon_content?: string
    is_birthdate?: boolean
}

export type FilterVariant = "default" | "tool"

export const FILTER_COL_SPAN_HALF = 2

export interface IAppliedFilter {
    filterId: number
    targetColumn: string
    type: string
    filterConstraint: string
    value: any
    isMultiple?: boolean | null
    isStrictMultiple?: boolean | null
    variableName?: string
    dynamicValueExpression?: string
}

export interface IToolTemplate {
    id: number
    sections: IToolTemplateSection[]
    name: string
}

export interface IToolTemplateSection {
    id: number
    name: string
    background_color: string
    after_filter_block_on_mobile: boolean
    padding: string
    tabs: IToolTemplateTab[]
}

export interface IToolTemplateTab {
    id: number
    tab_name: string
    blocks: IToolTemplateBlock[]
}

export interface IToolTemplateBlock {
    id: number
    col_span: number
    block_order: number
    block_padding: string
    displayed_in_main_template: boolean
    displayed_in_floating_template: boolean
    display_condition_expression: string
    type: IToolTemplateSectionBlockType
    expression: string
    image_url: string
    image_url_expression: string
    image_alt: string
    image_size: string
    text_content: string
    text_font_size: string
    text_font_weight: string
    text_color: string
    text_align: "left" | "center" | "right"
    button_label: string
    button_theme: string
    button_size: string
    button_target_url: string
    min_gauge_value: number
    max_gauge_value: number
    value_suffix: string
    expression_value: string
    table_expression_value: string
}

export enum IToolTemplateSectionBlockType {
    TEXT = "text",
    IMAGE = "image",
    BUTTON = "button",
    EXPRESSION = "expression",
}
